<template>
  <div class="p-6 max-w-3xl mx-auto">
    <button
      @click="$router.back()"
      class="text-blue-500 hover:underline mb-6"
    >
      ← Back
    </button>

    <div v-if="!tool" class="text-center py-10">
      Loading…
    </div>

    <div v-else>
      <h1 class="text-3xl font-bold mb-2">{{ tool.name }}</h1>
      <p class="text-sm text-gray-500 mb-4">
        Category: <strong>{{ tool.category || 'Uncategorized' }}</strong>
      </p>
      <p class="mb-6">{{ tool.description }}</p>

      <button
        @click="launch"
        class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Launch Tool
      </button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute }     from 'vue-router';
import { useMarketplaceStore } from '@/stores/marketplace';

export default {
  name: 'ToolDetailView',
  setup() {
    const route = useRoute();
    const store = useMarketplaceStore();
    const tool  = ref(null);

    async function load() {
      if (!store.tools.length) {
        await store.fetchTools();
      }
      // match id (string) against tool.id
      tool.value = store.tools.find(t => String(t.id) === route.params.id);
    }

    function launch() {
      store.launchTool(tool.value).catch(err =>
        alert(err.message || 'Error launching tool')
      );
    }

    onMounted(load);

    return { tool, launch };
  }
};
</script>

<style scoped>
/* add any detail-page styles here */
</style>
